import {
    datasetDetails,
    datasetTransferProcessing10,
    numberOfDatasets,
    numberOfParties,
    partyDetails
} from './gdpr_items.js';

export const MAP_ROLES = {
    'CO': 'CONTROLLER',
    'JC': 'JOINT CONTROLLER',
    'PR': 'PROCESSOR',
    'SU': 'SUB-PROCESSOR',
    'MU': 'MULTIPLE ROLES',
};

export function getPartyName(partyIndex, loops) {
    const loopStates = loops["parties_info_loop"].states;
    return loopStates[partyIndex][partyDetails.id].values[1] || loopStates[partyIndex][partyDetails.id].values[0];
}

export function getDatasetName(datasetIndex, loops) {
    const loopStates = loops["dataset_info_loop"].states;
    try {
        return loopStates[datasetIndex][datasetDetails.id].values[0];
    } catch (error) {
        return '';
    }
}


export function getPartiesExcludingOriginAndCohortOwner(states, globals, partyIndexI, loops) {
    const results = [];
    const nbParties = getNumberOfParties(states);
    const datasetIndex = loops["dataset_info_loop"].index - 1;
    for (let i = 0; i < nbParties; i++) {
        if (i !== partyIndexI && globals['CohortOwner'][datasetIndex] !== i) {
            results.push(i);
        }
    }
    return results;
}

export function filterBroadUse(parties, globals, partyIndexI, loops) {
    return filterFromGeneralCjPiPk("BroadUse", parties, globals, partyIndexI, loops)
}

export function filterSharing(parties, globals, partyIndexI, loops) {
    return filterFromGeneralCjPiPk("Sharing", parties, globals, partyIndexI, loops)
}

export function filterNoSharing(parties, globals, partyIndexI, loops) {
    return filterFromGeneralCjPiPk("Sharing", parties, globals, partyIndexI, loops, true)
}

export function filterGenerator(parties, globals, loops) {
    const datasetIndex = loops["dataset_info_loop"].index;
    return parties.filter(partyIndexK => globals["Generator"][datasetIndex - 1][partyIndexK])
}

export function filterNoGenerator(parties, globals, loops) {
    const datasetIndex = loops["dataset_info_loop"].index;
    return parties.filter(partyIndexK => !globals["Generator"][datasetIndex - 1][partyIndexK])
}

export function filterKeepData(parties, globals, partyIndexI, loops) {
    return filterFromGeneralCjPiPk("KeepData", parties, globals, partyIndexI, loops)
}

export function filterNoKeepData(parties, globals, partyIndexI, loops) {
    return filterFromGeneralCjPiPk("KeepData", parties, globals, partyIndexI, loops, true)
}

function filterFromGeneralCjPiPk(variableName, parties, globals, partyIndexI, loops, inverted) {
    const datasetIndex = loops["dataset_info_loop"].index;
    if (inverted === true) {
        return parties.filter(partyIndexK => globals[variableName][datasetIndex - 1][partyIndexI][partyIndexK] !== true)
    } else {
        return parties.filter(partyIndexK => globals[variableName][datasetIndex - 1][partyIndexI][partyIndexK])
    }
}

export function isRespNotInPRSU(globals, partyIndexI, loops) {
    const datasetIndex = loops["dataset_info_loop"].index;
    const excludeValues = ['PR', 'SU'];
    return excludeValues.indexOf(globals["ProvResp"][datasetIndex - 1][partyIndexI]) === -1 ||
        excludeValues.indexOf(globals["GenResp"][datasetIndex - 1][partyIndexI]) === -1 ||
        excludeValues.indexOf(globals["RecResp"][datasetIndex - 1][partyIndexI]) === -1
}

export function getNumberOfParties(states) {
    return parseInt(states[numberOfParties.id].values[0]);
}

export function getNumberOfDatasets(states) {
    return parseInt(states[numberOfDatasets.id].values[0]);
}

export function buildSafeGuardsOptions(prefix) {
    return [
        {key: prefix + "-cc", text: "based on standard contractual clauses by the European Commission", value: "CC"},
        {key: prefix + "-co", text: "based on consent", value: "CO"},
        {key: prefix + "-ii", text: "based on important public interest", value: "II"},
        {
            key: prefix + "-oo",
            text: "based on an exceptional one‑off transfer with information of the data protection authorities",
            value: "OO"
        }
    ]
}

export const DATASET_VARIABLES = [
    'CohortOwner',
    'CohortProvider',
    'CohortOwner_External',
    'Recruitment',
    'CohortPI',
    'CohortInstitution',
    'CohortData',
    'CohortDataString',
    'ProvData',
    'Generation',
    'GenResp',
    'Samples',
    'SamplesProviders',
    'SampleProvResp'
];
export const GLOBAL_VARIABLES_DEFAULT_FALSE = [
    'HomogeneousSampleFate',
    'HomogeneousKeepData',
    'HomogeneousPurposeKeep',
    'HomogeneousTerminateKeep',
    'HomogeneousFateTermination',
    'HomogeneousFate'
];

export const PARTY_VARIABLES = [
    "Processing",
    "ProcessingOther",
    "Processing_string",
    "Processing_resp",
    "HasRole",
    "Resp",
    "SG",
    "IC",
    "SubIC",
    "ExtShare",
    "AllSharedOutsideEu",
    "Recruit",
    "CohortDataPerParty",
    "RecruitResp",
    'SecondSharingExternalProcessor',
    'SecondSharingInternalProcessor'
];

export const TWO_DIMENSIONAL_VARIABLES = [ // [dataset][party]
    'SamplesReceivers',
    'TerminateSampleKeep',
    'SampleTerminateFate',
    'Provider',
    'Generator',
    'ProvResp',
    'SampleRecResp',
    'Transfers',
    'SampleFateTrigger',
    'SampleFate',
    'DataProvided',
    'SamplesProviders',
    'SampleProvResp',
    'Access',
    'DataTypesAccessed',
    'DataGenerated',
    'InternDAC',
    'InternDACDescription',
    // new
    "Unlimited",
    "SampleUnlimited",
    "InatSampleTransfer",
    "AllSamplesOutsideEu",
    "ExtPartyShared",
    "Recipients",
    "PurposeShare",
    "AllShare",
    "DataToBeShared",
    "HasInatTransfer",
    "InatDataToBeShared",
    "InatSampleShare",
    "InatSamplesToBeShared",
    "ExtCountries",
    "SampleExtCountries",
    "Safeguard",
    "SampleSafeguard",
    "TransferLimited",
    "SampleTransferLimited",
    "SampleSameShare",
    'SecondSharing',
    'ExternalSharing'
];


export const THREE_DIMENSIONAL_VARIABLES = [
    'Sharing',
    'KeepData',
    'BroadUse',
    'BroadUsePreliminaries',
    'IndependentSharing',
    'SpecificUseCond',
    'PurposeKeep',
    'OtherPurpose',
    'SpecificKeepCond',
    'ReducedDataset',
    'Fate',
    'FateArchiveDuration',
    'BackShare',
    'TerminateKeep',
    'FateTermination',
    'ReducedDatasetTermination',
    'DataTypesShared',
];

export function resetLoopIndex(loops, loopName) {
    try {
        loops['test'].index = 1
    } catch (TypeError) {
    }
}

export function uniqueDatatypes(nbParties, globals, datasetIndex, prefix) {
    const types = new Set();
    for (let i = 0; i < nbParties; i++) {
        uniqueDataTypesForPartyText(globals, datasetIndex, i, true).forEach(item => types.add(item));
    }
    return [...types].map((dataType, index) => {
        return {
            key: prefix + index, value: dataType, text: dataType
        }
    });
}

export function anySUPRMU(states, globals) {
    let anySU = false;
    let anyPROrMU = false;
    const numberOfParties = getNumberOfParties(states);
    for (let i = 0; i < numberOfParties; i++) {
        if (globals['Resp'][i]['P'] === 'SU' || globals['Resp'][i]['G'] === 'SU' || globals['Resp'][i]['A'] === 'SU' || globals['Resp'][i]['R'] === 'SU') {
            anySU = true;
            break;
        }
        if (globals['Resp'][i]['P'] === 'PR' || globals['Resp'][i]['G'] === 'PR' || globals['Resp'][i]['A'] === 'PR' || globals['Resp'][i]['R'] === 'PR' ||
            globals['Resp'][i]['P'] === 'MU' || globals['Resp'][i]['G'] === 'MU' || globals['Resp'][i]['A'] === 'MU' || globals['Resp'][i]['R'] === 'MU') {
            anyPROrMU = true;
        }
    }
    return {anySU, anyPROrMU};
}

function uniqueDataTypesReceivedByPartyText(globals, datasetIndex, partyIndex, nbParties) {
    const options = [];
    for (let i = 0; i < nbParties; i++) {
        if (globals["Sharing"][datasetIndex][i][partyIndex]) {
            options.push(...globals["DataTypesShared"][datasetIndex][i][partyIndex])
        }
    }
    return options;
}

function uniqueDataTypesForPartyText(globals, datasetIndex, partyIndex, includeAll) {
    let options;
    if (includeAll) {
        options = ["all datatypes"];
    } else {
        options = [];
    }
    // if party is generator we include data generated types
    if (globals['Generator'][datasetIndex][partyIndex] === true) {
        const dataGeneratedTypes = globals['DataGenerated'][datasetIndex][partyIndex] || [];
        for (let i = 0; i < dataGeneratedTypes.length; i++) {
            const dataGeneratedType = dataGeneratedTypes[i];
            options.push(dataGeneratedType);
        }
        // // if not include all and if we have some generated datatypes, we return only those + cohortDataPerParty
        // if (!includeAll && options.length > 0) {
        //     return options;
        // }
    }
    let recruitResp = false;
    try {
        recruitResp = ['CO', 'JC', 'PR', 'SU'].indexOf(globals['RecruitResp'][partyIndex][datasetIndex]) !== -1;
    } catch (error) {
    }
    if (includeAll || (!globals['Recruitment'][datasetIndex] && (globals['CohortProvider'][datasetIndex] === partyIndex) ||
        recruitResp)) {
        let hasSpecificTypes = false;
        // if we have some specific data types for this party, we add only those
        if (!includeAll) {
            try {
                options.push(...globals['CohortDataPerParty'][partyIndex][datasetIndex]);
                hasSpecificTypes = true;
            } catch (error) {
            }
        }
        if (!hasSpecificTypes) {
            const cohortsTypes = globals['CohortData'][datasetIndex] || [];
            for (let i = 0; i < cohortsTypes.length; i++) {
                const cohortType = cohortsTypes[i];
                options.push(cohortType);
            }
        }
    }
    if (globals['Provider'][datasetIndex][partyIndex] === true) {
        const dataProvidedTypes = globals['DataProvided'][datasetIndex][partyIndex] || [];
        for (let i = 0; i < dataProvidedTypes.length; i++) {
            const dataProvidedType = dataProvidedTypes[i];
            options.push(dataProvidedType);
        }
    }

    // keep uniq values only
    return [...new Set([...options])];
}

export function uniqueDatatypesReceivedByParty(globals, datasetIndex, partyIndex, prefix, nbParties) {
    const uniqueOptions = uniqueDataTypesReceivedByPartyText(globals, datasetIndex, partyIndex, nbParties);
    return uniqueOptions.map((dataType, index) => {
        return {
            key: prefix + index, value: dataType, text: dataType
        }
    });
}

export function uniqueDatatypesForParty(globals, datasetIndex, partyIndex, prefix) {
    const uniqueOptions = uniqueDataTypesForPartyText(globals, datasetIndex, partyIndex, false);

    return uniqueOptions.map((dataType, index) => {
        return {
            key: prefix + index, value: dataType, text: dataType
        }
    });
}

export function computeHomogeneousFate(globals, nbParties, nbDatasets) {
    // return an array of two elements, the first is a boolean showing if we have homogeneous fate
    // the second shows the fate value in this case, null otherwise
    return computeHomogeneousVariable(globals, nbParties, nbDatasets, 'Fate')
}

export function computeHomogeneousVariable(globals, nbParties, nbDatasets, variable) {
    // return an array of two elements, the first is a boolean showing if we have homogeneous value for 'variable'
    // the second shows the 'variable' value in this case, null otherwise
    let candidateIndex = 0;
    let previousFate;
    for (let datasetIndex = 0; datasetIndex < nbDatasets; datasetIndex++) {
        for (let partyIndexI = 0; partyIndexI < nbParties; partyIndexI++) {
            for (let partyIndexK = 0; partyIndexK < nbParties; partyIndexK++) {
                if (partyIndexK === partyIndexI ||
                    globals['CohortProvider'][datasetIndex] === partyIndexK ||
                    globals['Resp'][partyIndexK]['R'] === 'PR'
                ) {
                    continue;
                }
                if (globals['Sharing'][datasetIndex][partyIndexI][partyIndexK] !== true) {
                    return [false, null];
                }
                candidateIndex++;
                if (candidateIndex === 1) {
                    previousFate = globals[variable][datasetIndex][partyIndexI][partyIndexK];
                    continue;
                }
                if (globals[variable][datasetIndex][partyIndexI][partyIndexK] !== previousFate) {
                    return [false, null];
                }
            }
        }
    }
    if (candidateIndex === 0) {
        return [false, null];
    } else {
        return [true, previousFate]
    }
}


export function computeHomogeneousKeepData(globals, nbParties, nbDatasets) {
    // return an array of two elements, the first is a boolean showing if we have homogeneous keep data
    // the second shows the keep data value in this case, null otherwise
    let candidateIndex = 0;
    let previousKeepData;
    for (let datasetIndex = 0; datasetIndex < nbDatasets; datasetIndex++) {
        for (let partyIndexI = 0; partyIndexI < nbParties; partyIndexI++) {
            for (let partyIndexK = 0; partyIndexK < nbParties; partyIndexK++) {
                if (partyIndexK === partyIndexI ||
                    globals['CohortProvider'][datasetIndex] === partyIndexK ||
                    globals['Resp'][partyIndexK]['R'] === 'PR'
                ) {
                    continue;
                }
                if (globals['Sharing'][datasetIndex][partyIndexI][partyIndexK] !== true) {
                    return [false, null];
                }
                candidateIndex++;
                if (candidateIndex === 1) {
                    previousKeepData = globals['KeepData'][datasetIndex][partyIndexI][partyIndexK];
                    continue;
                }
                if (globals['KeepData'][datasetIndex][partyIndexI][partyIndexK] !== previousKeepData) {
                    return [false, null];
                }
            }
        }
    }
    if (candidateIndex === 0) {
        return [false, null];
    } else {
        return [true, previousKeepData]
    }
}

export function computeHomogeneousSampleFate(globals, nbParties, nbDatasets) {
    // return an array of two elements, the first is a boolean showing if we have homogeneous sample fate
    // the second contains the sample fate value in this case, null otherwise.
    if (globals['SamplesInvolved'] === true) {
        let sampleFateTriggerIndex = 0;
        let previousSampleFate;
        for (let datasetIndex = 0; datasetIndex < nbDatasets; datasetIndex++) {
            for (let partyIndex = 0; partyIndex < nbParties; partyIndex++) {
                if (globals['SampleFateTrigger'][datasetIndex][partyIndex] !== true) {
                    continue
                }
                sampleFateTriggerIndex++;
                if (sampleFateTriggerIndex === 1) {
                    previousSampleFate = globals['SampleFate'][datasetIndex][partyIndex];
                    continue;
                }
                if (globals['SampleFate'][datasetIndex][partyIndex] !== previousSampleFate) {
                    return [false, null];
                }
            }
        }
        return [true, previousSampleFate];
    } else {
        return [false, null];
    }
}

export function listOfTransferNotProcessing10Parties(globals, states, datasetIndex) {
    const nbParties = getNumberOfParties(states);
    const nbDatasets = getNumberOfDatasets(states);
    const parties = [];
    const cohortProvider = globals['CohortProvider'][datasetIndex];
    if (globals['HasRole'][cohortProvider]['P'] === true) {
        parties.push(cohortProvider);
        // if Provider is true for cohort provider, put it first in list
    }
    for (let partyIndex = 0; partyIndex < nbParties; partyIndex++) {
        if (partyIndex === globals['CohortProvider'][datasetIndex]) {
            continue
        }
        const provider = globals['Provider'][datasetIndex][partyIndex];
        const generator = globals['Generator'][datasetIndex][partyIndex];
        const processing10 = globals['Processing'][partyIndex][9];
        if (globals['RecruitResp'][partyIndex] === null || globals['RecruitResp'][partyIndex] === undefined) {
            globals['RecruitResp'][partyIndex] = Array(nbDatasets);
        }
        if (!processing10 && (
            ['CO', 'JC', 'PR', 'SU'].indexOf(globals['RecruitResp'][partyIndex][datasetIndex]) !== -1
            || provider
            || generator)
        ) {
            parties.push(partyIndex);
        }
    }
    return parties;
}

export function listOfTransferProcessing101112Parties(globals, states) {
    const nbParties = getNumberOfParties(states);
    const parties = [];
    for (let partyIndex = 0; partyIndex < nbParties; partyIndex++) {
        const processing10 = globals['Processing'][partyIndex][9];
        const processing11 = globals['Processing'][partyIndex][10];
        const processing12 = globals['Processing'][partyIndex][11];
        if (processing10 || processing11 || processing12) {
            parties.push(partyIndex);
        }
    }
    return parties;
}

export function getNamesForTransfersLoop(loopIndex, states, globals, loops) {
    const datasetIndex = loops['dataset_info_loop'].index - 1;
    const processingLoopName = "dataset_info_loop#" + globals['WhereEarlyTermination'] + '$' + loops['dataset_info_loop'].index;
    let parties;
    if (globals['WhereEarlyTermination'] === 'dataset_transfer_not_processing10') {
        parties = listOfTransferNotProcessing10Parties(globals, states, datasetIndex);
    } else {
        parties = listOfTransferProcessing101112Parties(globals, states)
    }
    let loop = loops[processingLoopName];
    const partiesIndex = loop !== undefined ? loop.index - 1 : 0;
    const partyIndexI = parties[partiesIndex];
    const cohortName = getDatasetName(datasetIndex, loops);

    const partyNameI = getPartyName(partyIndexI, loops);
    try {
        let selectedShareTo;
        if (globals['WhereEarlyTermination'] === 'dataset_transfer_not_processing10') {
            selectedShareTo = getAllSharedTo(states, globals, partyIndexI, datasetIndex);
        } else {
            selectedShareTo = states[datasetTransferProcessing10.id].values[0];
        }
        const partnerIndex = selectedShareTo[loopIndex - 1];
        const partyName = getPartyName(partnerIndex, loops);
        return {cohortName, partyNameI, partyIndexI, partyName, partnerIndex, datasetIndex, selectedShareTo};
    } catch (e) {
        return {cohortName, partyNameI, partyIndexI, datasetIndex};
    }
}

export function getAllSharedTo(states, globals, partyIndex, datasetIndex) {
    const numberOfParties = getNumberOfParties(states);
    const parties = [];
    for (let i = 0; i < numberOfParties; i++) {
        if (globals['Sharing'][datasetIndex][partyIndex][i] === true) {
            parties.push(i);
        }
    }
    return parties;
}

